import {useCustomQuery} from '@salesforce/commerce-sdk-react'

/**
 * Hook to fetch real-time inventory.
 */
const useRealTimeInventory = (productIds) => {
    const {refetch, data: availableSkus} = useCustomQuery(
        {
            options: {
                method: 'GET',
                parameters: {
                    c_sku: productIds
                },
                customApiPathParameters: {
                    apiVersion: 'v1',
                    endpointPath: '/inventory',
                    apiName: 'product-realtime-inventory'
                }
            },
            rawResponse: false
        },
        {
            enabled: false
        }
    )

    return {
        availableSkus,
        refetch
    }
}

export default useRealTimeInventory
